import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Outcomeinfologs = ()=>{
    const [outcomeinfologs, setOutcomeinfologs] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`outcomeInfoLog?page=${page}`);
            setOutcomeinfologs(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`outcomeinfologs/${id}`);
            setOutcomeinfologs(outcomeinfologs.filter((outcomeinfolog) => outcomeinfolog.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'Bet Outcome info'}>
            <InnerNav createLink={'/outcomeinfologCreate'} listLink={'/outcomeinfologs'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Bet id </th>
                                    <th className="px-4 py-3">Outcome </th>
                                    <th className="px-4 py-3">Payout </th>
                                    <th className="px-4 py-3">Outcome Date </th>
                                    <th className="px-4 py-3">Winnings </th>
                                    <th className="px-4 py-3">Withholding Tax </th>
                                    <th className="px-4 py-3">Wallet Balance Outcome </th>
                                    <th className="px-4 py-3">Sent To Kra </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {outcomeinfologs && outcomeinfologs.length > 0 ? (
                                         outcomeinfologs.map((outcomeinfolog)=>(
                                             <tr key={outcomeinfolog.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{outcomeinfolog.id}</td>
                                                 <td className="px-4 py-3 text-sm">{outcomeinfolog.betId}</td>
                                                 <td className="px-4 py-3 text-sm">{outcomeinfolog.outcome}</td>
                                                 <td className="px-4 py-3 text-sm">{outcomeinfolog.payout}</td>
                                                 <td className="px-4 py-3 text-sm">{outcomeinfolog.outcomedate}</td>
                                                 <td className="px-4 py-3 text-sm">{outcomeinfolog.winnings}</td>
                                                 <td className="px-4 py-3 text-sm">{outcomeinfolog.withholdingTax}</td>
                                                 <td className="px-4 py-3 text-sm">{outcomeinfolog.walletBalanceOutcome}</td>
                                                 <td className="px-4 py-3 text-sm">{outcomeinfolog.sent_to_kra}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/outcomeinfolog/${outcomeinfolog.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(outcomeinfolog.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         ))
                                ) : (
                                            <tr>
                                                <td colSpan="10" className="text-center py-5 text-gray-500">No data to display </td>
                                            </tr>
                                         )}
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default Outcomeinfologs;